import { GET_DATA_CONFIRM, GET_DATA_CONFIRM_SUCCEEDED, GET_DATA_PLANHANDLE_STEP, GET_DATA_PLANHANDLE_STEP_SUCCEEDED, ISRESULT, REQUERT_CONFIRM_FAILED, REQUERT_PLANHANDLE_STEP_FAILED } from "./actionTypes"

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

export const GetDataConfirmAction = (DataPlan) => {
    return {
        type: GET_DATA_CONFIRM,
        DataPlan: DataPlan
    }
}

export const GetDataConfirmSuccessAction = (DataPlan) => {
    return {
        type: GET_DATA_CONFIRM_SUCCEEDED,
        DataPlan: DataPlan
    }
}

export const RequertConfirmFaileAction = (Err) => {
    return {
        type: REQUERT_CONFIRM_FAILED,
        err: Err
    }
}
export const GetDataPlanHandleStepAction = (DataPlanStep) =>{
    return {
        type: GET_DATA_PLANHANDLE_STEP,
        DataPlanStep: DataPlanStep
    }
}
export const GetDataPlanHandleStepSuccessAction = (DataPlanStep) =>{
    return {
        type: GET_DATA_PLANHANDLE_STEP_SUCCEEDED,
        DataPlanStep: DataPlanStep
    }
}
export const RequertPlanHandleStepFaileAction = (Err) => {
    return {
        type: REQUERT_PLANHANDLE_STEP_FAILED,
        err: Err
    }
}